/**
 * Created by ndzak on 4/22/2016.
 */
import $http from 'axios';
import axios from "axios/index";

let API_ENDPOINT = "api/";

//const API_ENDPOINT = 'https://api.blablacommentz.com/api/';

//const API_ENDPOINT = 'http://tutors.dev/api/';

export default class Http {

    constructor($auth){
        
        if($auth){
            this.token = $auth.getToken();
            this._bearer = 'Bearer ' + (this.token ? this.token : "");
        }	
        
    }

    get(url){
             
        return $http.get(API_ENDPOINT + url, {
            method: 'GET',
            headers: {
                'Authorization': this._bearer,
                'Accept': 'application/json'
            }
        }).then((response) => {            
            return Promise.resolve(response);            
        }).catch((error) =>{     	    
            return Promise.reject(error.response);
        });
    }

    post(url, data){
        return $http.post(API_ENDPOINT + url, data, {
            method: 'POST',
            headers: {                
                'Authorization': this._bearer,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }

        }).then((response) => {
            return Promise.resolve(response);                      
        }).catch((error) =>{	            
            return Promise.reject(error.response);
        });
    }

    put(url, data) {
        return $http.put(API_ENDPOINT + url, data, {
            method: 'PUT',
            headers: {
                'Authorization': this._bearer,
                'Accept': 'application/json',                
                'Content-Type': 'application/json'
            }
        }).then((response) => {
            return Promise.resolve(response);                     
        }).catch((error) =>{
            return Promise.reject(error.response);
        });
    }

    delete(url) {
        return $http.delete(API_ENDPOINT + url, {
            method: 'DELETE',
            headers: {                
                'Authorization': this._bearer,
                'Accept': 'application/json'
            }
        }).then((response) => {
            return Promise.resolve(response);                      
        }).catch((error) =>{
            return Promise.reject(error.response);
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/Http.js